import { Navigate, Route, Routes } from 'react-router-dom'
import { GeneratorProvider } from './context/GeneratorContext'
import { TourProvider } from './context/TourContext'
import EnglishGenerator from './generators/EnglishGenerator'
import MathematicsGenerator from './generators/MathematicsGenerator'
import NorwegianGenerator from './generators/NorwegianGenerator'
import { useTranslate } from '~/ur-react-hooks'

const Generator: React.FC = () => {
  const translations = useTranslate({
    newWorksheet: 'common.new-worksheet',
  })

  return (
    <GeneratorProvider defaultName={translations.newWorksheet}>
      <TourProvider autoStart={true}>
        <Routes>
          <Route path="/mathematics" element={<MathematicsGenerator />} />
          <Route path="/norwegian" element={<NorwegianGenerator />} />
          <Route path="/english" element={<EnglishGenerator />} />
          <Route path="*" element={<Navigate to="/generator/mathematics" replace />} />
        </Routes>
      </TourProvider>
    </GeneratorProvider>
  )
}

export default Generator
